import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import StudentTimetableWrapper from "./components/StudentTimetableWrapper";
import TeacherTImetableWrapper from "./components/TeacherTImetableWrapper";
import ClassTimetableWrapper from "./components/ClassTimetableWrapper";
import BellSchedule from "./components/BellSchedule";
import SchoolDays from "./components/SchoolDays";
import Routines from "./components/Routines";
import ImportLog from "./components/ImportLog";
import Checklist from "./components/Checklist";
import PeriodsSetup from "./components/PeriodsSetup";
import Spaces from "./components/Spaces";
import YardDuties from "./components/YardDuties";

export default store => ({
  path: "timetable",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "timetableAdmin" */ "./components"),
        import(
          /* webpackChunkName: "timetableAdmin" */ "./modules/TimetableModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "timetableAdmin",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    StudentTimetableWrapper(store),
    TeacherTImetableWrapper(store),
    ClassTimetableWrapper(store),
    BellSchedule(store),
    SchoolDays(store),
    Routines(store),
    ImportLog(store),
    Checklist(store),
    PeriodsSetup(store),
    Spaces(store),
    YardDuties(store),
  ],
});
